import React from 'react';

const Play = props => (
  <svg width={21} height={21} viewBox="0 0 21 21" {...props}>
    <path d="M2.66 1.36C2.2.88 1 .88 1 1.36v19.28c0 .48 1.2.48 1.67 0l15.67-8.78c.47-.47.48-1.24.01-1.72L2.66 1.36zm0 0" />
  </svg>
);

export default Play;
